define("ember-intl/-private/error-types", ["exports", "intl-messageformat"], function (_exports, _intlMessageformat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MISSING_TRANSLATION = _exports.MISSING_INTL_API = void 0;
  /**
   * An error that indicates a required Intl API was not available
   * at runtime. This is generally resolved by polyfilling the missing API.
   *
   * @private
   * @hide
   */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore If the consuming project uses `--isolatedModules`, `const enums`
  // may not be used. Since `ember-cli-babel` does not care for `const enums`
  // _anyway_ , this is not an issue.
  const MISSING_INTL_API = _exports.MISSING_INTL_API = _intlMessageformat.ErrorCode.MISSING_INTL_API;

  /**
   * An error type that indicates a translation that was looked up
   * by a specific key was not found.
   *
   * @private
   * @hide
   */
  const MISSING_TRANSLATION = _exports.MISSING_TRANSLATION = 'MISSING_TRANSLATION';
});